import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import { flushSync } from "react-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          navigate("/", { replace: true });
          return;
        }

        // Exchange session_id for session_token cookie (with retry)
        let response = null;
        let lastError = null;
        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            response = await fetch(`${API}/auth/session`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ session_id: sessionId }),
            });
            if (response.ok) break;
            lastError = `Status ${response.status}`;
          } catch (fetchErr) {
            lastError = fetchErr.message;          }
          // Wait before retry (500ms, 1s)
          if (attempt < 2) await new Promise(r => setTimeout(r, 500 * (attempt + 1)));
        }

        if (!response || !response.ok) {
          throw new Error("Session exchange failed");
        }

        const userData = await response.json();

        // Store token for cross-domain support
        if (userData.session_token) {
          localStorage.setItem("cadii_token", userData.session_token);
        }

        // Force synchronous state commit before navigation
        flushSync(() => {
          setUser(userData);
        });

        // Navigate with user data in state as backup
        navigate("/dashboard", { replace: true, state: { user: userData } });
      } catch {
        navigate("/", { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#1B4D3E] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#64748B] font-medium">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
